import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { AppOptionsPriceBaseComponent } from './product-price-base.componen';
@Component({
  selector: 'app-product-price',
  styleUrls: ['./product-price.component.scss'],
  templateUrl: './product-price.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [DecimalPipe, CurrencyPipe],
})
export class AppProductPriceComponent extends AppOptionsPriceBaseComponent implements OnInit, OnChanges {
  @Input() showDiscounted = false;
  @Input() showSale = false;

  @Input()
  showPercentage: boolean = false;
  @Input()
  showLabel: boolean = false;
  @Input() showFromPriceText: boolean = false;
  @Input() customFields?: { type: string; value: string }[] = [];

  unitInPack: number | null = null;
  pricePerUnit: number = 0;

  protected override update() {
    super.update();

    if (this.customFields) {
      const customField = this.customFields.find((customField) => customField.type == 'CF_UNITS');
      this.unitInPack = customField ? parseInt(customField.value) : null;
      if (this.unitInPack && this.priceInfo) {
        this.pricePerUnit = Math.ceil((this.priceInfo?.price / this.unitInPack) * 100) / 100;
      }
    }
  }

  get discountPercentage(): number {
    if (!this.priceInfo || !this.priceInfo.oldPrice || !this.hasDiscount) {
      return 0;
    }
    return (this.diffPrice / this.priceInfo.oldPrice) * 100;
  }

  get diffPrice(): number {
    if (!this.priceInfo) {
      return 0;
    }
    if (this.crossedPriceManager.bundleOldPrice) {
      return this.crossedPriceManager.bundleOldPrice - this.priceInfo.price;
    }
    if (this.priceInfo.oldPrice) {
      return this.priceInfo.oldPrice - this.priceInfo.price;
    }
    return 0;
  }

  get currency(): string | undefined {
    return this.productPriceInfo?.currency;
  }
}
